<template>
  <P-dialog
    :append-to-body="true"
    :dialog="config"
    @closePerDialog="closePerDialog"
    @confirmPerDialog="confirmPerDialog"
    @before-close="hideDialog"
    class="person-dialog"
  >
    <div class="data-show" slot="left">
      <div class="data-search">
        <span class="org-span">组织架构</span>
        <el-input v-model="searchPer" placeholder="搜索员工" @change="search">
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="search"
            style="cursor: pointer;"
          ></i>
        </el-input>
      </div>
      <P-tree ref="tree" :keywork="searchOrg" :treeConfig="treeConfig" class="structure-tree"></P-tree>
      <div class="member-container">
        <div class="member-line" v-for="(item, index) in treeConfig.memberList" :key="index">
          <div class="top">
            <el-checkbox :disabled="isDisabled" v-model="item.isCheck" @change="selectChange(item)"></el-checkbox>
           <svg v-if="item.sex === 1" class="icon" aria-hidden="true">
              <use xlink:href="#iconman" />
            </svg>
            <svg v-else class="icon" aria-hidden="true">
              <use xlink:href="#iconwoman" />
            </svg>
            <div class="name">{{item.userName}}</div>
            <div class="code">{{item.userCode}}</div>
            <span class="post">{{item.mainPostName}}</span>
          </div>
          <div :class="{bottom: true, hidden: treeConfig.isHideOrg}">{{item.orgName}}</div>
        </div>
      </div>
    </div>
    <div class="checked-list" slot="right">
      <div class="checked-list-title">
        <span class="checked-num">
          已选
          <i>&nbsp;{{treeConfig.selectList.length}}&nbsp;</i>
        </span>
        <span class="clear-all" @click="clearAll">清空</span>
      </div>
      <div class="right-content">
        <el-tooltip
          class="select-line"
          placement="left-start"
          v-for="(item, index) in treeConfig.selectList"
          :key="index"
        >
          <div slot="content">
            {{item.userName}}&nbsp;&nbsp; {{item.userCode}} &nbsp;&nbsp;{{item.mainPostName}}
            <br />
            <br />
            {{item.orgName}}
          </div>
          <div class="line-content">
            <div class="line-person">
          <svg v-if="item.sex === 1" class="icon" aria-hidden="true">
                  <use xlink:href="#iconman" />
                </svg>
                <svg v-else class="icon" aria-hidden="true">
                  <use xlink:href="#iconwoman" />
                </svg>
              <span class="line-name">{{item.userName}}</span>
            </div>
            <div class="del" @click="del(item,index)">
              <i class="el-icon-close"></i>
            </div>
          </div>
        </el-tooltip>
      </div>
    </div>
  </P-dialog>
</template>
<script>
import PDialog from './PDialog';
import PTree from './pTree';
import { searchUser } from './org';
export default {
    name: 'Person-dialog',
    components: {
        PDialog,
        PTree
    },
    props: {
        config: {
            type: Object
        }
    },
    data() {
        return {
            isDisabled: false,
            treeConfig: {
                memberList: [],
                selectList: [],
                isHideOrg: true
            },
            searchPer: ''
        };
    },
    methods: {
        search() {
            searchUser({ queryParam: this.searchPer }).then(res => {
                this.treeConfig.memberList = [];
                if (+res.code === 0) {
                    res.data.list.forEach(it => {
                        const a = this.treeConfig.selectList.filter(
                            e => e.userCode === it.userCode
                        );
                        if (a.length > 0) {
                            it.isCheck = true;
                        } else {
                            it.isCheck = false;
                        }
                        this.treeConfig.memberList.push(it);
                    });
                }
            });
        },
        hideDialog(val) {
            this.$emit('before-close', val);
        },
        closePerDialog(val) {
            this.$emit('closePerDialog', val);
        },
        confirmPerDialog(val) {
            val.selectList = this.treeConfig.selectList;
            this.$emit('confirmPerDialog', val);
        },
        selectChange(item) {
            if (item.isCheck) {
                if (this.treeConfig.selectList.length < 1) {
                    this.treeConfig.selectList.push(item);
                    this.isDisabled = true;
                } else {
                    this.isDisabled = false;
                }
            } else {
                this.treeConfig.selectList.forEach((it, id) => {
                    if (item.userCode === it.userCode) {
                        this.treeConfig.selectList.splice(id, 1);
                    }
                });
            }
        },
        del(item, index) {
            // 删一条
            this.isDisabled = false;
            this.treeConfig.selectList.splice(index, 1);
            this.treeConfig.memberList.forEach(it => {
                if (it.userCode === item.userCode) {
                    it.isCheck = false;
                }
            });
        },
        clearAll() {
            // 清空
            this.isDisabled = false;
            const a = [...this.treeConfig.selectList];
            this.treeConfig.selectList = [];
            a.forEach(e => {
                this.treeConfig.memberList.forEach(el => {
                    if (e.userCode === el.userCode) {
                        el.isCheck = false;
                    }
                });
            });
        }
    },
    computed: {
        searchOrg: {
            set(val) {
                this.config.value = val;
            },
            get() {
                return this.config.value;
            }
        }
    },
    watch: {
        config: {
            handler(n, o) {
                this.treeConfig.selectList = n.selectList.map(v => {
                    if (v) {
                        this.isDisabled = true;
                    }
                    return v;
                });
                this.treeConfig = Object.assign(this.treeConfig, n.tree);
            },
            deep: true
        }
    }
};
</script>
<style lang="less">
.person-dialog {
    .icon {
        width: 16px;
        height: 16px;
        font-size: 14px;
    }

    .dialog-body {
        overflow: hidden;
        width: 100%;
        height: 444px;
    }

    .el-dialog__body {
        padding: 0;
        border-bottom: 1px solid #e6e6e6;
    }

    .data-show {
        float: left;
        padding: 16px 10px 0 16px;
        width: 660px;
        height: 100%;
        border-right: 1px solid #e6e6e6;

        /* background-color: blue; */
        box-sizing: border-box;
    }

    .checked-list {
        float: left;
        padding: 16px 16px 0 10px;
        width: 300px;
        height: 100%;
        box-sizing: border-box;
    }

    .checked-list-select {
        margin-bottom: 20px;
    }

    .right-content {
        overflow: auto;
        margin-top: 10px;
        width: 100%;
        height: calc(100% - 50px);

        .select-line {
            display: flex;
            align-items: center;
            width: 100%;
            height: 40px;

            .line-content {
                display: flex;
                width: 100%;
                height: 40px;
            }
        }

        :hover {
            background-color: #f0f8fa;
        }
    }

    .line-person {
        display: flex;
        align-items: center;
        padding-left: 20px;
        width: 80%;
    }

    .line-name {
        padding-left: 10px;
    }

    .del {
        width: 20%;
        text-align: right;
        cursor: pointer;
    }

    .el-icon-close {
        padding-right: 10px;
    }

    .checked-list-title {
        padding: 0 10px 0 20px;
        width: 100%;
        height: 40px;
        color: #666;
        background-color: #f2f2f2;
        line-height: 38px;
        box-sizing: border-box;
    }

    .checked-num i {
        font-style: normal;
        color: #3ea4eb;
    }

    .clear-all {
        float: right;
        cursor: pointer;
    }

    .checked-every {
        padding: 0 10px 0 20px;
        width: 100%;
        height: 38px;
        color: #666;
        line-height: 38px;
        box-sizing: border-box;
    }

    .checked-every:hover {
        background-color: #f0f8fa;
    }

    .checked-every span:last-child {
        float: right;
        font-size: 18px;
        color: #aaa;
        cursor: pointer;
    }

    .checked-items {
        overflow-y: scroll;
        width: 100%;
        height: 90%;
    }

    .data-search {
        padding: 0 5px 0 10px;
        width: 100%;
        height: 40px;
        background-color: #f2f2f2;
        line-height: 40px;
        box-sizing: border-box;

        .org-span {
            height: 40px;
        }
    }

    .data-search span:first-child {
        float: left;
        font-size: 14px;
        color: #666;
    }

    .data-search .el-input {
        float: right;
        width: 45%;
    }

    .structure-tree.el-tree {
        float: left;
        overflow: auto;
        margin-top: 10px;
        width: 255px;
        height: calc(100% - 50px);
        box-sizing: border-box;
        border-right: 1px solid #e6e6e6;
    }

    .member-container {
        float: left;
        overflow: auto;
        padding: 0 0 0 10px;
        margin-top: 10px;
        width: 375px;
        height: calc(100% - 50px);
        box-sizing: border-box;

        .member-line {
            width: 100%;

            .top {
                display: flex;
                align-items: center;
                width: 100%;
                height: 40px;
                direction: row;

                .el-checkbox {
                    margin-right: 15px;
                    margin-left: 10px;
                }

                .name {
                    display: inline-block;
                    overflow: hidden;
                    margin-right: 10px;
                    margin-left: 10px;
                    width: 60px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .code {
                    display: inline-block;
                    overflow: hidden;
                    margin-right: 10px;
                    width: 90px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .post {
                    display: inline-block;
                    overflow: hidden;
                    width: 120px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    color: #999;
                }
            }

            .bottom {
                padding-bottom: 5px;
                padding-left: 60px;
                width: 100%;
                color: #999;
            }

            .hidden {
                display: none;
            }
        }
    }
}
</style>
